import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { NodeUtils } from '@core/utils/node.utils';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { BaseComponent } from '@portal-shared/app/components/base-components/base.component';
import { GuidString } from '@portal-shared/app/typings/guid-string.type';
import { DepartmentGroupRowDto } from '@services/dtos/rows/department-group-row.dto';
import { BudgetGroupBaseComponent } from '@shared/components/budget-group-base/budget-group-base.component';
import { CellDropZoneComponent } from '@shared/components/cell-drop-zone/cell-drop-zone.component';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IRowNode } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { DepartmentGroupRow } from '../../rows/groups/department-group.row';
import { PlanningGroupRow } from '../../rows/groups/planning-group.row';

@Component({
  selector: 'al-department-group-cell-renderer',
  templateUrl: 'department-group-cell-renderer.component.html',
  styleUrl: 'department-group-cell-renderer.component.scss',
  imports: [BudgetGroupBaseComponent, CellDropZoneComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartmentGroupCellRendererComponent extends BaseComponent implements ICellRendererAngularComp {
  public readonly faUsers = faUsers;
  public readonly translationKey = 'common.department';

  public department?: DepartmentGroupRowDto;
  public node!: IRowNode<DepartmentGroupRow>;
  public refreshSubject = new Subject<void>();

  public expandAll: boolean = false;

  public get isDroppable() {
    return NodeUtils.isCellDroppable(this.node);
  }

  public constructor(private change: ChangeDetectorRef) {
    super();
  }

  public agInit(params: ICellRendererParams<DepartmentGroupRow, GuidString>) {
    this.node = params.node;
    this.department = this.node.data?.dto;

    const parent = this.node.parent as IRowNode<PlanningGroupRow>;
    if (parent.data?.expandAll) {
      if (this.node.data) {
        this.node.data.expandAll = true;
      }
      this.expand(true);
    }
  }

  public refresh(_: ICellRendererParams<DepartmentGroupRow>) {
    this.refreshSubject.next();
    this.change.markForCheck();
    return true;
  }

  public expand(expand = true) {
    this.node.setExpanded(expand);
  }
}
